import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeMaschineProps {
    data: any;
    maschineSelected: any;
}

export class DateneingabeMaschine extends React.Component<DateneingabeMaschineProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_MASCHINEN}
                    module={IDs.MOD_ETOOL}
                    directEditFormularOf={{ tid: (this.props.maschineSelected || {}).tid || null }}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    customCssStyle={{
                        formcontainer: { marginTop: 'unset', padding: 'unset' }
                    }}
                    inlineFormular
                    formAutoSave
                    customFormConfig={{ standort_tid: { readonly: true } }}
                    hideTitel
                    validateField={this.validateField}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_MASCHINEN)}
                    globalData={this.props.data}
                />
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_MASCHINEN, key, value, data, onValueChange);
    }
}
